module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div id="map_directions"></div>\n<div id="map_input_container">\n	<input id="pac-input" class="controls" type="text" placeholder="Search Box">\n	<div id="clear_map" ></div>\n</div>\n<div id="map_canvas"></div>';

}
return __p
}